/**
 * Cornice comune delle tre sezioni di amministrazione.
 *
 * Tre rotte e non tre schede in una pagina sola: un indirizzo per sezione si
 * può mettere fra i preferiti, ricaricare e citare in una segnalazione, e ogni
 * pagina carica solo i propri dati — la lista utenti e le statistiche globali
 * sono due query non leggere, e con le schede si pagherebbero entrambe per
 * guardarne una.
 */

import { NavLink, Outlet } from 'react-router-dom';
import './admin.css';

const SECTIONS = [
  { to: '/admin/users', label: 'Utenti' },
  { to: '/admin/llm-models', label: 'Modelli AI' },
  { to: '/admin/llm-usage', label: 'Consumo LLM' },
  { to: '/admin/llm-incidents', label: 'Incidenti LLM' },
];

export function AdminLayout() {
  return (
    <div className="admin">
      <header className="page-header">
        <div>
          <h1>Amministrazione</h1>
          <p className="page-header__subtitle">
            Gestione della piattaforma. Il privilegio arriva dalla variabile d'ambiente{' '}
            <code>ADMIN_EMAILS</code>: non esiste alcun modo, da dentro l'applicazione, di
            promuovere un utente ad amministratore.
          </p>
        </div>
      </header>

      <nav className="admin__tabs" aria-label="Sezioni di amministrazione">
        {SECTIONS.map((section) => (
          <NavLink
            key={section.to}
            to={section.to}
            className={({ isActive }) => `admin__tab ${isActive ? 'admin__tab--active' : ''}`}
          >
            {section.label}
          </NavLink>
        ))}
      </nav>

      <Outlet />
    </div>
  );
}
